<div class="content-with-chat h-full">
	<div
		class="video-section"
		[class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)"
		[style.display]="hidePlayerMobile() ? 'none' : null"
	>
		<!-- Race Info Bar -->
		@if (raceStatus()) {
			<div class="race-info-bar">
				<div class="race-info-item">
					<span class="race-info-label">LAP</span>
					<span class="race-info-value lap-value">{{ raceStatus()?.currentLap | json }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">ELAPSED</span><span class="label-short">ELAP</span></span>
					<span class="race-info-value">{{ timeStatus()?.elapsedTime | timespan }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">REMAINING</span><span class="label-short">REM</span></span>
					<span class="race-info-value">{{ timeStatus()?.remainingTime | timespan }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label">TRACK TEMP</span>
					<span class="race-info-value">{{ trackTempDisplay() }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">TEMPERATURE</span><span class="label-short">TEMP</span></span>
					<span class="race-info-value">{{ ambientTempDisplay() }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">WIND SPEED</span><span class="label-short">WIND SPD</span></span>
					<span class="race-info-value">{{ windSpeedDisplay() }}</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">WIND DIRECTION</span><span class="label-short">WIND DIR</span></span>
					<span class="race-info-value wind-direction-value">
						<span
							class="wind-direction-arrow"
							[style.transform]="'rotate(' + windDirectionDegrees() + 'deg)'"
							aria-hidden="true"
						>
							↑
						</span>
						{{ windDirectionLabel() }}
					</span>
				</div>
				<div class="race-info-item">
					<span class="race-info-label"><span class="label-full">LOCAL TIME</span><span class="label-short">TIME</span></span>
					<span class="race-info-value">{{ localTimeDisplay() }}</span>
				</div>
			</div>
		}

		<div
			class="video-container"
			id="videoContainer"
			[ngClass]="containerAspectRatioClass"
			[class.layout-single]="layoutService.isLayout(VideoLayout.SINGLE)"
			[class.layout-side-by-side]="layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)"
			[class.layout-stacked]="layoutService.isLayout(VideoLayout.STACKED)"
			[class.layout-large-left]="layoutService.isLayout(VideoLayout.LARGE_LEFT)"
			[class.layout-large-right]="layoutService.isLayout(VideoLayout.LARGE_RIGHT)"
			[class.layout-grid-2x2]="layoutService.isLayout(VideoLayout.GRID_2X2)"
			[class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)"
		>
			<!-- Main Video (always shown) -->
			<vb-lxp-video-slot
				#livestreamPlayerSlot
				class="aspect-video"
				[ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mt-auto' : ''"
				id="mainVideo"
				[label]="'Main Feed'"
				[showBadge]="true"
				[time]="'3:42:18'"
				[isLive]="true"
				[progressPercent]="55"
				[volumePercent]="70"
				(playerClosed)="onPlayerClosed($event)"
			/>

			<vb-lxp-video-slot
				#livestreamPlayerSlot
				class="aspect-video"
				[ngClass]="layoutService.isLayout(VideoLayout.LARGE_LEFT) || layoutService.isLayout(VideoLayout.LARGE_RIGHT) || layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mt-auto' : ''"
				[hidden]="layoutService.isLayout(VideoLayout.SINGLE)"
				[label]="'Onboard Camera'"
				[showBadge]="true"
				[time]="'3:42:18'"
				[isLive]="true"
				[src]="''"
				(playerClosed)="onPlayerClosed($event)"
			/>

			<vb-lxp-video-slot
				#livestreamPlayerSlot
				class="aspect-video mb-auto"
				[label]="'Turn 1'"
				[hidden]="layoutService.isLayout(VideoLayout.SINGLE)
					|| layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)
					|| layoutService.isLayout(VideoLayout.STACKED)"
				[showBadge]="true"
				[time]="'3:42:18'"
				[isLive]="true"
				[src]="''"
			/>

			<vb-lxp-video-slot
				#livestreamPlayerSlot
				class="aspect-video"
				[ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mb-auto' : ''"
				[hidden]="layoutService.isLayout(VideoLayout.SINGLE)
					|| layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)
					|| layoutService.isLayout(VideoLayout.STACKED)
					|| layoutService.isLayout(VideoLayout.LARGE_LEFT)
					|| layoutService.isLayout(VideoLayout.LARGE_RIGHT)"
				[label]="'Paddock'"
				[showBadge]="true"
				[time]="'3:42:18'"
				[isLive]="true"
				[src]="''"
				(playerClosed)="onPlayerClosed($event)"
			/>
		</div>
	</div>

	<!-- Chat Panel -->
	<div class="panel-container" [ngClass]="hidePlayerMobile() ? 'grow-1' : ''">
		@if (timingPanel.isOpen() && !isSwissTimingEnabled && !isMobile()) {
			<button
				type="button"
				class="advanced-toggle-btn"
				[class.expanded]="moreColumns()"
				(click)="toggleAdvanced()"
				[title]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
				[attr.aria-label]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
			>
				<i [class]="moreColumns() ? 'bi bi-chevron-right' : 'bi bi-chevron-left'"></i>
			</button>
		}
		<vb-lxp-panel
			#timingPanel
			class="timing-panel-host"
			[panelKey]="'timing'"
			[defaultOpenState]="true"
			[panelClass]="hidePlayerMobile() ? 'timing-panel max-h-full!' : 'timing-panel overflow-visible!'"
			[panelHeaderClass]="'timing-panel-header'"
			[panelBodyClass]="'timing-panel-body-wrapper vb-lxp-panel-body-scroll flex-col'"
			[disablePin]="isMobile() || false"
			[ngClass]="{
				'timing-panel-open': timingPanel.isOpen(),
				'timing-panel-more-info': moreColumns(),
				'grow-1': timingPanel.isPinned() && timingPanel.isOpen(),
				'min-w-116': !raceStatus() && !moreColumns() && timingPanel.isOpen(),
				'min-w-235': !raceStatus() && moreColumns() && timingPanel.isOpen(),
			}"
		>
			<div header class="timing-header-content">
				<div class="flex items-center gap-2 font-semibold w-full">
					<span class="text-xl">Live Timing</span>

					<div>
						<span
							class="btn-panel-header text-xl live-timing-header-content"
							[ngClass]="'btn-primary-filled'"
							(click)="openFullTimingPage()"
							target="_blank"
							[title]="'Full Timing'"
						>
							Full Timing
					</span>
					</div>
					@if (raceStatus()) {
						@if (visibilitiesService.controlVisibilities().showPanelMapControl) {
							<span
								class="btn-panel-header text-xl"
								[ngClass]="'btn-primary-filled'"
								(click)="openFullMapPage()"
								>Map</span>
						}
						@if (isMobile()) {
							<button
								type="button"
								class="btn-panel-header text-xl"
								(click)="toggleAdvanced()"
								[title]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
								[attr.aria-label]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
								[ngClass]="moreColumns() ? 'btn-primary-filled' : 'btn-outlined'"
							>
								<i [class]="moreColumns() ? 'bi bi-chevron-right' : 'bi bi-chevron-left'"></i>
							</button>
						}
						<div class="flex items-center gap-2 ml-auto"></div>
						<app-race-class
							[classes]="raceSessionService.raceClasses$ | async"
							(selectionChange)="onClassSelectionChange($event)"
						></app-race-class>
						<button
							class="header-btn column-settings-btn"
							(click)="openColumnSettings()"
							[title]="'Customize Columns'"
						>
							<i class="bi bi-sliders2"></i>
						</button>
					} @else {
						@if (isMobile()) {
							<button
								type="button"
								class="btn-panel-header text-xl"
								(click)="toggleAdvanced()"
								[title]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
								[attr.aria-label]="moreColumns() ? 'Collapse timing tower' : 'Expand timing tower'"
								[ngClass]="moreColumns() ? 'btn-primary-filled' : 'btn-outlined'"
							>
								<i [class]="moreColumns() ? 'bi bi-chevron-right' : 'bi bi-chevron-left'"></i>
							</button>
						}
					}
				</div>
				@if (showTwitchStreamSelector) {
					<div class="flex items-center gap-2 mt-2">
						<span>Race Feed:</span>
						<vb-lxp-checkbox
							[(checked)]="livestreamViewService.isTwitchStreamSelected"
							(checkedChange)="onTwitchStreamToggled($event)"
							>Twitch</vb-lxp-checkbox
						>
					</div>
				}
			</div>
			@if (isSwissTimingEnabled) {
				<div body class="timing-panel-body-content" class="timing-advanced-active">
					<vb-lxp-swiss-timing-iframe></vb-lxp-swiss-timing-iframe>
				</div>

			} @else {
				<div body class="timing-panel-body-content" [class.timing-advanced-active]="moreColumns()">
					<div class="timing-tower-wrapper" [ngClass]="{ 'timing-advanced-active': moreColumns() }">
						<vb-lxp-timing-tower
							#timingTower
							class="w-full sector-secondary"
							[enableColumnCustomization]="true"
							[enableMoreColumns]="moreColumns()"
							[selectedClasses]="selectedClasses()"
							[activeClass]="'active-tower-item'"
							[activeNumberClass]="'text-secondary'"
							(selectionAdded)="onTimingTowerSelectionAdded($event)"
							(selectionRemoved)="onTimingTowerSelectionRemoved($event)"
						></vb-lxp-timing-tower>
					</div>
				</div>
			}
		</vb-lxp-panel>
		<vb-lxp-panel
			#chatPanel
			[panelKey]="'chat'"
			[panelClass]="'chat-panel'"
			[panelHeaderClass]="'chat-panel-header'"
			[panelBodyClass]="'chat-panel-body-wrapper px-1'"
			[disablePin]="isMobile()!"
			[ngClass]="chatPanel.isPinned() && chatPanel.isOpen() ? 'chat-panel-pinned grow-1' : ''"
		>
			<div header class="chat-header-content">
				<div class="chat-header-main">
					<span>{{ streamChatTitle }}</span>
					@if (enableStreamChatPopout) {
						<button
							type="button"
							class="chat-popout-btn"
							(click)="openStreamChatPopout()"
							aria-label="Open stream chat in a new window"
							title="Pop out chat"
						>
							<svg
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								viewBox="0 0 24 24"
								aria-hidden="true"
							>
								<path
									d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
								></path>
							</svg>
						</button>
					}
				</div>
			</div>
			<div body>
				<app-twitch-chat></app-twitch-chat>
			</div>
		</vb-lxp-panel>
	</div>
</div>
